<template>
    <b-modal
        :id="'accounts-update-user-modal' + user.id"
        title="Gebruiker bewerken"
        :ok-title="$t('common.save')"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @show="show()">
        <b-form-group
            id="input-group-1"
            label="Voornaam:"
            label-for="input-1">
            <b-form-input
                id="input-1"
                v-model="name"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-2"
            label="Tussenvoegsel:"
            label-for="input-2">
            <b-form-input
                id="input-2"
                v-model="preposition"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-3"
            label="Achternaam:"
            label-for="input-3">
            <b-form-input
                id="input-3"
                v-model="surname"
                type="text"></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-4"
            label="E-mail:"
            label-for="input-4">
            <b-form-input
                id="input-4"
                v-model="email"
                type="email"></b-form-input>
        </b-form-group>

        <b-form-group
            label="Scholen:"
            label-for="schools">
            <design-2021-apprentice-multiselect-component
                v-model="schools"
                label="name"
                :options="allSchools"
                track-by="id">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group label="Huidige school:">
            <b-form-select
                v-model="currentSchool"
                :options="user.schools"
                text-field="name"
                value-field="id">
            </b-form-select>
        </b-form-group>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-accounts-index-update-user-modal-component',

    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            name: this.user.name,
            preposition: this.user.preposition,
            surname: this.user.surname,
            email: this.user.email,
            schools: this.user.schools,
            currentSchool: this.user.userable_id,
            allSchools: [],
        };
    },
    methods: {
        save() {
            let data = {
                name: this.name,
                preposition: this.preposition,
                surname: this.surname,
                email: this.email,
                schools: this.schools.map((school) => school.id),
                userable_id: this.currentSchool,
            };

            this.alert.saving();

            this.axios
                .post(this.routes.schoolAccountUser(this.user.id), data)
                .then((response) => {
                    ords.use('user').update(response.data, this.user.id);

                    this.alert.success();
                })
                .catch(() => {
                    this.alert.ajaxError(error);
                });
        },

        getAllSchools() {
            axios
                .get(this.routes.schoolsGet())
                .then((response) => {
                    this.allSchools = response.data.map((school) => ({
                        id: school.id,
                        name: school.name,
                    }));
                })
                .catch(() => {
                    this.alert.ajaxError(error);
                });
        },

        show() {
            this.name = this.user.name;
            this.preposition = this.user.preposition;
            this.surname = this.user.surname;
            this.email = this.user.email;
            this.username = this.user.username;
            this.password = this.user.password;
            this.role = this.user.role;
            this.schools = this.user.schools;
            this.getAllSchools();
        },
    },
};
</script>

<style scoped></style>
